import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from "../../context/AuthContext";
import AlertMessage from "../include/AlertMessage";
import { account, storage } from "../../appwrite/config";
import ConfirmationPopup from "../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../Pagination";

var _ = require('lodash');


function Events() {
    const { role, user, logout } = useAuth();
    const [allEvents, setallEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const token = sessionStorage.getItem('JWT_TOKEN');
    const location = useLocation();
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [showPopup, setShowPopup] = useState(false); // popup state
    const [deleteId, setDeleteId] = useState(null); // store user id for delete
    const [deleting, setDeleting] = useState(false);
    const redirectHistory = useNavigate();

    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get("page")) || 1;
    const LIMIT = 10;

    const fetchEvents = async (page = currentPage) => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/events`, {
                params: {
                    latitude: 0,
                    longitude: 0,
                    radius: 0,
                    userId: role === "admin" ? null : user?.$id,
                    page,
                    limit: LIMIT
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = await response.data;

            if (Array.isArray(data.data) && data.data.length > 0) {
                const finaldata = data.data;
                setallEvents(finaldata);

                setTotalPages(response.data.pagination.totalPages);
                setTotalRecords(response.data.pagination.total);
            } else {
                setallEvents([]);
            }
            setLoading(false);
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.documentElement.className = "";

        fetchEvents(currentPage);
    }, [currentPage]);

    const handleDelete = async () => {
        if (!deleteId) return;

        // Sirf admin ko allow karo
        if (role && role !== "admin") {
            redirectHistory("/events");
            return;
        }

        try {
            setLoading(true);
            setDeleting(true);

            /*const detailresponse = await axios.get(`${process.env.REACT_APP_API_URL}/fetcheventdetail/${deleteId}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = detailresponse.data.data;
            const imageIds = Array.isArray(resdata.imageID) ? resdata.imageID : [];
            for (let id of imageIds) {
                await storage.deleteFile(process.env.REACT_APP_BUCKET_ID, id);
            } */

            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deleteevent/${deleteId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token // Replace with your token
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                const updatedData = allEvents.filter(event => event.$id !== deleteId);

                setallEvents(updatedData);
                setAlert({ type: "success", message: "Event deleted successfully!" });

                // ⭐ If page becomes empty go to previous page
                if (updatedData.length === 0 && currentPage > 1) {
                    setSearchParams({
                        page: currentPage - 1
                    });
                }
            }
            //fetchEvents();
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setShowPopup(false); // close popup after action
            setDeleteId(null); // reset id
            setTimeout(() => {
                setLoading(false);
                setDeleting(false);
            }, 1000);
        }
    };


    //const visiblePages = getPagination(currentPage, totalPages);

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li>Events</li>
                    </ul>
                    <Link to="/event/add" className='button blue'>Add Event</Link>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">

                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Events
                            </p>
                        </header>
                        <div className="card-content">
                            {alert.message && (
                                <AlertMessage
                                    type={alert.type}
                                    message={alert.message}
                                    onClose={() => setAlert({ type: "", message: "" })}
                                    duration={3000}
                                />
                            )}
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                Array.isArray(allEvents) && allEvents.length > 0 ? (
                                    <>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Expiry</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(allEvents || []).map((item, index) => (
                                                    <tr key={item.$id}>
                                                        <td data-label="Shop">{item.name}</td>
                                                        <td data-label="Code">{item.latitude}</td>
                                                        <td data-label="Description">{item.longitude}</td>
                                                        <td data-label={item.expiryDate?.split('T')[0]}>{item.expiryDate?.split('T')[0]}</td>
                                                        <td className="actions-cell">
                                                            <div className="buttons right nowrap">
                                                                {["admin", "event"].includes(role) && (
                                                                    <>
                                                                        <Link to={`/eventbookings/${item.$id}`} className='button green'> Booking</Link>
                                                                        <Link to={`/event/edit/${item.$id}?page=${currentPage}`} className='button small green'> <span className="icon"><i className="mdi mdi-lead-pencil"></i></span></Link>
                                                                    </>
                                                                )}
                                                                {role === "admin" && (
                                                                    <button
                                                                        className="button small red"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            if (deleting) return;
                                                                            setDeleteId(item.$id);
                                                                            setShowPopup(true);
                                                                        }}
                                                                        style={{
                                                                            cursor: deleting ? "not-allowed" : "pointer",
                                                                            opacity: deleting ? 0.5 : 1
                                                                        }}
                                                                    >
                                                                        <span className="icon"><i className="mdi mdi-trash-can"></i></span>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {totalPages > 1 && (
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                totalRecords={totalRecords}
                                                onPageChange={(page) =>
                                                    setSearchParams({
                                                        page
                                                    })
                                                }
                                            />
                                        )}
                                    </>
                                ) : (
                                    <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Confirmation Popup */}
            <ConfirmationPopup
                show={showPopup}
                onConfirm={handleDelete}
                onCancel={() => {
                    if (!deleting) {
                        setShowPopup(false);
                    }
                }}
                title="Confirm Delete"
                message={
                    deleting
                        ? "Deleting event..."
                        : "Are you sure you want to delete this event?"
                }
                deleting={deleting}
            />
        </section >
    );
}

export default Events;